import { Reveal } from "@/components/Reveal";
import {
  Accordion,
  AccordionItem,
  AccordionTrigger,
  AccordionContent,
} from "@/components/ui/accordion";
import { useLang } from "@/i18n";

export const Objections = () => {
  const { t } = useLang();
  const items = t("landing.faq_items");
  return (
    <section id="faq" className="relative z-10 py-24 md:py-36 bg-paper-deep/40" data-testid="faq-section">
      <div className="max-w-[1100px] mx-auto px-5 md:px-10">
        <Reveal className="mb-14 max-w-2xl">
          <p className="font-body text-xs uppercase tracking-[0.24em] text-terracotta mb-5">
            {t("landing.faq_eyebrow")}
          </p>
          <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl leading-[1.02] tracking-tight text-ink mb-5">
            {t("landing.faq_h")}
          </h2>
          <p className="font-body text-base md:text-lg text-ink-soft leading-relaxed">
            {t("landing.faq_description")}
          </p>
        </Reveal>

        <Reveal>
          {/* type="multiple" — more than one FAQ may be open at once */}
          <Accordion type="multiple" className="w-full border-t border-ink/15" data-testid="faq-accordion">
            {Array.isArray(items) &&
              items.map((f, i) => (
                <AccordionItem key={i} value={`item-${i}`} className="border-ink/15">
                  <AccordionTrigger
                    data-testid={`faq-trigger-${i}`}
                    className="font-serif text-xl md:text-2xl text-ink hover:no-underline py-6 [&>svg]:text-terracotta [&>svg]:h-5 [&>svg]:w-5"
                  >
                    {f.q}
                  </AccordionTrigger>
                  <AccordionContent className="pb-6">
                    <p className="font-body text-base md:text-lg text-ink-soft leading-relaxed max-w-2xl">
                      {f.a}
                    </p>
                  </AccordionContent>
                </AccordionItem>
              ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
};
